import axios from './index'

export default {
  getConsentFormList() {
    return axios.get('/consentForm/getConsentForms')
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  insertCustomerConsentForm(url) {
    return axios.post(url)
      .then(response => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  getConsentForm(id) {
    return axios.get('/api/customConsentForm/getCustomConsentFormForEdit?id=' + id)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  getCustomConsentFormPreview(id) {
    return axios.get('/api/customConsentForm/getCustomConsentFormPreview?customConsentFormId=' + id)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  submitConsentForm(url, model) {
    return axios.post(url, model)
      .then(response => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  // Converter servisi (ConsentFormConverter:BaseUrl) yapılandırılmamış ortamlarda
  // "Dosyadan Oluştur" hiç gösterilmez.
  getConvertAvailability() {
    return axios.get('/api/CustomConsentForm/ConvertFromDocumentAvailability')
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  // FormData; Content-Type'ı tarayıcı boundary ile kendisi koyar (bkz. customer.js import).
  convertFromDocument(form) {
    return axios.post('/api/CustomConsentForm/ConvertFromDocument', form)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  getCustomerConsentFormClauses(customerConsentFormId) {
    return axios.get('/consentForm/GetCustomerConsentFormClauses?customerConsentFormId=' + customerConsentFormId)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  getCustomerConsentFormPreviewHtml(customerId, customerConsentFormId) {
    return axios.get('/consentForm/GetCustomerConsentFormPreviewHtml?customerId=' + customerId +
      '&customerConsentFormId=' + customerConsentFormId)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  saveDigitalSignature(model) {
    return axios.post('/consentForm/SaveDigitalSignature', model)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  }
}
